import Vue from "vue";
import { colors } from "vuetify/lib";
const moment = require("moment");

const getDefaultState = () => {
  return {
    logs: [],
  };
};
const state = getDefaultState();

const mutations = {
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },

  SET_LOG(state, payload) {
    state.logs = payload;
  },
};

const actions = {
  createLog({ commit }, logdata) {
    let self = this;
    console.log(this._vm);
    console.log(logdata);
    /*  this._vm.$firebase
      .firestore()
      .collection("logs")
      .add({
        action: logdata.action,
        displayName:logdata.displayName,
        user: logdata.uid,
        value: logdata.value,
        date:this._vm.$moment().format("YYYY-MM-DD HH:mm:ss")
      })
      .then((docRef) => {
        console.log("Log written with ID: ", docRef.id);
      })
      .catch((error) => {
        console.error("Error adding Log: ", error);
      }); */
  },
};

const getters = {
  logs: (state) => {
    return state.logs;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
